export default __webpack_public_path__ + "assets/meest_verkocht.6774fa62.svg";